import { render, staticRenderFns } from "./LoaderIcon.vue?vue&type=template&id=49401cb0&"
import script from "./LoaderIcon.vue?vue&type=script&lang=ts&"
export * from "./LoaderIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports